// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_0c9150f","open":"_a38ed01","title":"_4afedfd","icon":"_db14f62","iconOpen":"_75170a1"};